import { useAuth } from '../contexts/AuthContext'
import { Navigate } from 'react-router-dom'
import { Shield, AlertTriangle } from 'lucide-react'

const SuperAdminOnlyRoute = ({ children }) => {
    const { user, loading, isSuperAdmin } = useAuth()

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">Verifying authentication...</p>
                </div>
            </div>
        )
    }

    if (!user) {
        console.log('No user found, redirecting to login')
        return <Navigate to="/login" />
    }

    if (!isSuperAdmin()) {
        console.log('User is not Super Admin, redirecting to camera monitoring')
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center max-w-md mx-auto p-8">
                    <div className="bg-red-100 rounded-full p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                        <Shield className="h-8 w-8 text-red-600" />
                    </div>
                    <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
                    <p className="text-gray-600 mb-6">
                        This page is restricted to Super Admin users only. You don't have the required permissions to access this resource.
                    </p>
                    <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 mb-6">
                        <div className="flex">
                            <AlertTriangle className="h-5 w-5 text-yellow-400 mr-2 mt-0.5" />
                            <div>
                                <p className="text-sm text-yellow-800">
                                    <strong>Current Role:</strong> {user.role?.name || 'No role assigned'}
                                </p>
                                <p className="text-sm text-yellow-800">
                                    <strong>Required Role:</strong> Super Admin
                                </p>
                            </div>
                        </div>
                    </div>
                    <button
                        onClick={() => window.history.back()}
                        className="bg-indigo-600 text-white px-6 py-2 rounded-md hover:bg-indigo-700 transition-colors mr-3"
                    >
                        Go Back
                    </button>
                    <button
                        onClick={() => window.location.href = '/camera-monitoring'}
                        className="bg-gray-600 text-white px-6 py-2 rounded-md hover:bg-gray-700 transition-colors"
                    >
                        Go to Camera Monitoring
                    </button>
                </div>
            </div>
        )
    }

    return children
}

export default SuperAdminOnlyRoute
